'use strict';

let Q = lazy(first);
Q.A = lazy(all);

export default Q;


function first() {
	for (let entry of Array.from(arguments)) {
		if (entry) return entry;
	}
}


function all() {
	var retval;
	for (let entry of Array.from(arguments)) {
		if (!entry) {
			return false;
		} else if (!retval || retval.time < entry.time) {
			retval = entry;
		}
	}
	return retval;
}


function processArg(arg) {
	switch (typeof arg) {
		case 'string':
			return incident => incident.timestamps[arg];
		case 'function':
			return arg;
		default:
			throw `Query arguments must be strings or functions`;
	}
}


function lazy(func) {
	return function() {
		const queries = Array.from(arguments).map(processArg);
		return function(incident) {
			return func.apply(null, queries.map(query => query(incident)));
		}
	}
}
